var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.$style.button,on:{"click":() => _vm.$emit('click')}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }